/**
 * Custom Hero Banner JavaScript
 * Scoped functionality for scroll indicator
 */

class CustomHero {
  constructor() {
    this.scrollIndicators = document.querySelectorAll('.custom-hero__scroll-indicator');
    this.init();
  }

  init() {
    if (this.scrollIndicators.length > 0) {
      this.scrollIndicators.forEach(indicator => {
        indicator.addEventListener('click', (e) => {
          e.preventDefault();
          this.scrollToNextSection(indicator);
        });
      });
    }
  }

  scrollToNextSection(indicator) {
    // Encontrar la sección hero que contiene este indicador
    const heroSection = indicator.closest('[id^="shopify-section-"]');
    
    if (!heroSection) return;

    // Buscar la siguiente sección hermana
    let nextSection = heroSection.nextElementSibling;
    
    // Saltar elementos que no sean secciones de Shopify
    while (nextSection && !nextSection.id.startsWith('shopify-section-')) {
      nextSection = nextSection.nextElementSibling;
    }

    if (nextSection) {
      // Scroll directo a la siguiente sección
      const targetSectionTop = nextSection.offsetTop - 20; // 20px de margen extra

      window.scrollTo({
        top: targetSectionTop,
        behavior: 'smooth'
      });
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CustomHero();
});

// Initialize for dynamic content (if sections are added via AJAX)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('custom-hero')) {
    new CustomHero();
  }
}); 